/* eslint-disable vue/no-unused-vars */
<template>
  <div class="main">
    <!-- Left -->
    <div class="main_l">
      <div class="title">单位</div>
      <div class="mt15">
        <el-input v-model="keyInput" @change="changekeyinput" prefix-icon="el-icon-search" placeholder="请输入可进行模糊查询"></el-input>
        <div class="mt15">
          <el-tree :data="treedata" node-key="id" @node-click="handleNodeClick" default-expand-all :expand-on-click-node="false" accordion>
            <span class="custom-tree-node" slot-scope="{ node, treedata }">
              <span class="tree_txt">{{ node.data.organizationName }}</span>
              <el-link type="primary" :underline="false" class="tree_add_btn" @click="clickAddNode(node)"><img src="../../assets/images/tree_add_btn.png" alt=""></el-link>
              <el-link type="primary" :underline="false" icon="el-icon-edit"   @click="clickEditNode(node)"></el-link>
              <el-link v-if="node.data.parentId > 0" type="danger" :underline="false" icon="el-icon-delete"   @click="clickDeleteNode(node)"></el-link>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <!-- Left End -->

    <!-- 添加 -->
    <el-dialog title="添加" :visible.sync="dialogAdd" width="385px" class="confirmDel">
      <div class="confirmMsg">
        <el-form :model="addForm" class="add_organization">
          <el-form-item label="名称" :label-width="formLabelWidth1" :required=true>
            <el-input v-model="addForm.organizationName" autocomplete="off" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth1">
            <el-input v-model="addForm.organizationAddress" autocomplete="off" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="简介" :label-width="formLabelWidth1">
            <el-input v-model="addForm.organizationInfo" autocomplete="off" placeholder="请输入简介"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth1">
            <el-input v-model="addForm.organizationNote" autocomplete="off" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrganization" >确定</el-button>
        <el-button @click="dialogAdd = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 添加组织架构 End -->

    <!-- 编辑组织架构 -->
    <el-dialog title="编辑组织架构" :visible.sync="dialogEdit" width="20%" class="confirmDel">
      <div class="confirmMsg">
        <el-form :model="editForm" class="add_organization">
          <el-form-item label="名称" :label-width="formLabelWidth1" :required=true>
            <el-input v-model="editForm.organizationName" autocomplete="off" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth1">
            <el-input v-model="editForm.organizationAddress" autocomplete="off" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="简介" :label-width="formLabelWidth1">
            <el-input v-model="editForm.organizationInfo" autocomplete="off" placeholder="请输入简介"></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth1">
            <el-input v-model="editForm.organizationNote" autocomplete="off" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editOrganization" >确定</el-button>
        <el-button @click="dialogEdit = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑组织架构 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'

Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      treedata: [],
      dialogAdd: false,
      dialogEdit: false,
      keyword: '',
      keyInput: '',
      formLabelWidth: '120px',
      formLabelWidth1: '90px',
      // 新增
      addForm: {
        parentId: '',
        organizationName: '',
        organizationType: '',
        organizationAddress: '',
        organizationInfo: '',
        organizationNote: ''
      },
      editForm: {
        id: '',
        organizationName: '',
        organizationAddress: '',
        organizationInfo: '',
        organizationNote: ''
      }
    }
  },
  mounted () {
    this.getUnitTree()
  },
  methods: {
    handleNodeClick (data) {
    },
    changekeyinput (value) {
      if (value.length > 0) {
        this.findUnitByKeyWord(value)
      } else {
        this.getUnitTree()
      }
    },
    clickAddNode (node) {
      this.dialogAdd = true
      this.addForm.parentId = node.data.id
      this.addForm.organizationName = ''
      this.addForm.organizationType = '0'
      this.addForm.organizationAddress = ''
      this.addForm.organizationInfo = ''
      this.addForm.organizationNote = ''
    },
    clickEditNode (node) {
      this.dialogEdit = true
      this.editForm.id = node.data.id
      this.editForm.organizationName = node.data.organizationName
      this.editForm.organizationAddress = node.data.organizationAddress
      this.editForm.organizationInfo = node.data.organizationInfo
      this.editForm.organizationNote = node.data.organizationNote
    },
    clickDeleteNode (node) {
      var that = this
      this.$deleteConfirm('确定删除该单位？').then(function () {
        that.deleteOrganization(node.data.id)
      })
    },
    getUnitTree: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getUnitTree, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.treedata = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    findUnitByKeyWord: function (keyword) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.keyword = keyword
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_findUnitByKeyWord, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.treedata = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    deleteOrganization: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_deleteOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUnitTree()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addOrganization: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.addForm.parentId
      data.organizationName = that.addForm.organizationName
      data.organizationType = that.addForm.organizationType
      data.organizationAddress = that.addForm.organizationAddress
      data.organizationInfo = that.addForm.organizationInfo
      data.organizationNote = that.addForm.organizationNote
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dialogAdd = false
            that.getUnitTree()
            Vue.prototype.FunRemindAllways('添加成功')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.FunRemindAllways('添加出错')
        })
    },
    editOrganization: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editForm.id
      data.organizationName = that.editForm.organizationName
      data.organizationAddress = that.editForm.organizationAddress
      data.organizationInfo = that.editForm.organizationInfo
      data.organizationNote = that.editForm.organizationNote
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dialogEdit = false
            that.getUnitTree()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.main .main_l{
  width: 600px;
  flex-shrink: 0;
  border-right: 1px solid #e6e6e6;
}
.search {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 200px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 110px;
    }
  }
}

// 表格头部背景色
/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

/deep/ .el-table__expand-icon {
  display: none;
}

.el-form-item {
  margin-bottom: 16px;
}

.organization_code{
  width: 127px;
  margin-right: 12px;
}

// 新增组织架构
.add_organization{
  padding-right: 15px;

  .organization_code{
    width: 157px;
    margin-right: 12px;
  }
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;

      & em{
        font-style: normal;
        color: #4976ff;
      }
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.sgdInfo{
  padding-left: 20px;
}

.tableOut{
  margin-top: 15px;

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:nth-last-child(2) {
    border-radius: 0 10px 0 0;
  }
}

// 内表格
.tableInner{
  margin-top: 20px;

  ::-webkit-scrollbar{
    width: 6px;  /*滚动条宽度*/
    height: 6px;  /*滚动条高度*/
  }

  /*定义滑块 内阴影 圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: #4976ff;  /*滚动条的背景颜色*/
  }

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:last-child {
    border-radius: 0 10px 0 0;
  }
}

.addUser_body{
  padding: 15px 40px 0 30px;
}

/deep/ .el-table__expanded-cell {
  padding: 20px 0px 0px 0px;
  margin: 15px;
  border: 1px solid #4976ff;
  border-radius: 10px;
  overflow: hidden;
}

.position{
  overflow: hidden;
  height: 433px;
  background: #f7f7f7;
}

// 弹出框
/deep/ .el-dialog__body {
  padding: 20px;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  background: #f6f6fa;
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.confirmDel /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.confirmMsg{
  padding: 10px 0 10px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  & em{
    font-style: normal;
    margin-right: 10px;
    padding: 2px 6px;
    background: #f6f6fa;
    border-radius: 4px;
  }
}

.tree_txt{
  padding: 2px 6px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tree_btn{
  margin-right: 5px;
}

.blue{
  color: #4976ff;
}

/deep/ .el-tree-node__content {
  height: 36px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}
/deep/ .el-tree-node__expand-icon {
    color: #4976ff;
  }
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4976ff;
  background-color: #fff;
}
/deep/ .el-tree-node__content:hover {
  color: #4976ff;
  background-color: #fff;
}

// /deep/ .custom-tree-node {
//   padding-right: 0px;
// }

// 组织架构
/deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 8px;
}

.tree_add_btn{
  margin-right: 5px;
}
</style>
